import { useCallback, useContext, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCustomRouteMatch } from '../useCustomRouteMatch';
import {
  hideNavigationModal,
  hideSortProvidersModal,
  showNavigationModal,
  showSortProvidersModal,
} from '../../redux/actions/ui/modals';
import {
  isNavigationOpenSelector,
  isSortingProvidersOpenSelector,
} from '../../redux/reducers/ui/modals';
import CustomRouterContext from '../../components/Router/RouterContext';
import { NAVBAR_ITEMS, ROUTES_WITH_SORTING_ICON } from '../../constants/navbar';

export const useNavbarClickHandlers = () => {
  const { path } = useCustomRouteMatch();
  const isNavigationMenuOpened = useSelector(isNavigationOpenSelector);
  const isSortingProvidersOpened = useSelector(isSortingProvidersOpenSelector);
  const dispatch = useDispatch();
  const router = useContext(CustomRouterContext);

  const filterClickHandler = useCallback(() => {
    let actionCreator = () => {};
    if (ROUTES_WITH_SORTING_ICON.includes(path)) {
      actionCreator = isSortingProvidersOpened
        ? hideSortProvidersModal
        : showSortProvidersModal;
    } else {
      actionCreator = isNavigationMenuOpened
        ? hideNavigationModal
        : showNavigationModal;
    }
    dispatch(actionCreator());
  }, [isNavigationMenuOpened, dispatch, isSortingProvidersOpened, path]);

  const backClickHandler = useCallback(() => {
    router.goBack();
  }, [router]);

  return useMemo(
    () => ({
      [NAVBAR_ITEMS.FILTER]: filterClickHandler,
      [NAVBAR_ITEMS.BACK]: backClickHandler,
    }),
    [filterClickHandler, backClickHandler]
  );
};
